import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";
import { useMutation } from "urql";

const ActivateWorkflowMutation = graphql(`
  mutation ActivateWorkflow($id: ID!) {
    activateWorkflow(id: $id) {
      id
      isActive
    }
  }
`);

const DeactivateWorkflowMutation = graphql(`
  mutation DeactivateWorkflow($id: ID!) {
    deactivateWorkflow(id: $id) {
      id
      isActive
    }
  }
`);

export function useToggleWorkflowStatus() {
  const [, activateMutation] = useMutation(ActivateWorkflowMutation);
  const [, deactivateMutation] = useMutation(DeactivateWorkflowMutation);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const toggleStatus = useCallback(
    async (id: string, currentIsActive: boolean) => {
      setIsPending(true);
      setError(null);

      try {
        const response = currentIsActive ? await deactivateMutation({ id }) : await activateMutation({ id });

        if (response.error) {
          throw response.error;
        }

        return true;
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error("Failed to toggle workflow status");

        console.error("unable to toggle workflow status", error);
        setError(error);

        return false;
      } finally {
        setIsPending(false);
      }
    },
    [activateMutation, deactivateMutation],
  );

  return { toggleStatus, isPending, error };
}
